import { Tree } from "primereact/tree";

export function CustomTree({ values, selectionKeys, onSelectionChange }) {
    console.log("selectionKeys>>", selectionKeys, values);
    return <Tree selectionMode="single" className="border-none" value={values} selectionKeys={selectionKeys} onSelectionChange={onSelectionChange} />;
}
